import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { mascaraMoedaReal } from "../../../utils/mascaras/mascaraMoedaReal";
import { SelectField } from "../../ui";

interface SelectNfsEmpresaProps {
  name: string;
  methods: any;
  idWork?: string;
  disabled?: boolean;
  required?: boolean;
  label?: string;
}

export function SelectNfsEmpresa({
  name,
  methods,
  idWork,
  disabled = false,
  required = false,
  label = "Selecione uma Nota Fiscal",
}: SelectNfsEmpresaProps) {
  const [notas, setNotas] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await baseApiService.get("service-invoice/select");
      let notasRetorno = data.data.data || [];
      if (idWork) {
        notasRetorno = notasRetorno.filter(
          (nota: any) => nota.idWork === idWork
        );
      }
      setNotas(notasRetorno);
    };
    fetchData();
  }, [idWork]);

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <SelectField
          label={label}
          value={field.value || ""}
          onChange={(e) => field.onChange(e.target.value)}
          required={required}
          disabled={disabled}
        >
          <option value="" />
          {notas.map((nota) => (
            <option key={nota.id} value={nota.id}>
              {`${nota.number} - ${
                nota.work?.workName || ""
              } - ${mascaraMoedaReal(nota.netValue)} - ${new Date(
                nota.competenceDate
              ).toLocaleDateString("pt-BR")}`}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
